/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Shipping_Fee_Payer_CustomerInputs */

const vi_carrier_form_shipping_fee_payer_customer = /** @type {(inputs: Carrier_Form_Shipping_Fee_Payer_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người nhận trả cước`)
};

/**

* @param {Carrier_Form_Shipping_Fee_Payer_CustomerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_shipping_fee_payer_customer = /** @type {((inputs?: Carrier_Form_Shipping_Fee_Payer_CustomerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Shipping_Fee_Payer_CustomerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_shipping_fee_payer_customer(inputs)
});